import { render, staticRenderFns } from "./group-members.vue?vue&type=template&id=70e159e6&scoped=true"
import script from "./group-members.vue?vue&type=script&lang=js"
export * from "./group-members.vue?vue&type=script&lang=js"
import style0 from "./group-members.vue?vue&type=style&index=0&id=70e159e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e159e6",
  null
  
)

export default component.exports